import * as React from 'react'
import { Paper } from '@material-ui/core'
import styles from './DashboardToolbar.module.scss'

const DashboardToolbar: React.FC = ({ children }) => <Paper className={styles.container}>{children}</Paper>

export default DashboardToolbar
